<template>
  <div class="auth-page">
    <main class="auth-shell">
      <router-link class="auth-brand" to="/">
        <span class="brand-mark" aria-hidden="true">
          <span></span>
        </span>
        <strong>Codex API</strong>
        <em>codex API 中转服务</em>
      </router-link>

      <section class="auth-card">
        <div class="auth-heading">
          <h1>登录控制台</h1>
          <p>登录以管理 Codex API 接入信息</p>
        </div>

        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-position="top">
          <el-form-item label="邮箱" prop="email">
            <el-input v-model.trim="loginForm.email" placeholder="请输入邮箱" prefix-icon="el-icon-message" />
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              v-model="loginForm.password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              show-password
              @keyup.enter.native="submitLogin"
            />
          </el-form-item>
          <el-form-item label="验证码" prop="captchaCode">
            <div class="captcha-row">
              <el-input
                v-model.trim="loginForm.captchaCode"
                placeholder="请输入4位验证码"
                maxlength="4"
                prefix-icon="el-icon-picture-outline"
                @keyup.enter.native="submitLogin"
              />
              <button class="captcha-image" type="button" title="点击刷新验证码" @click="loadCaptcha">
                <img v-if="captchaImage" :src="captchaImage" alt="验证码" />
                <span v-else>刷新</span>
              </button>
            </div>
          </el-form-item>
          <p class="auth-help">验证码为 4 位 1-9 数字，点击图片可刷新。</p>
          <p class="auth-help"><router-link to="/forgot-password">忘记密码？</router-link></p>
          <el-checkbox v-model="loginForm.agreed">
            我已阅读并同意
            <router-link to="/terms">服务条款</router-link>
          </el-checkbox>
          <el-button class="auth-submit" type="primary" round :loading="submitting" @click="submitLogin">
            登录控制台
          </el-button>
          <el-button class="auth-secondary" round @click="$router.push('/register')">
            创建新账户
          </el-button>
        </el-form>
      </section>

      <div class="auth-links">
        <router-link to="/">返回首页</router-link>
        <span>没有账户？<router-link to="/register">创建账户</router-link></span>
      </div>
      <p class="auth-copy">© 2026 Codex API. 保留所有权利。</p>
    </main>
  </div>
</template>

<script>
import { fetchCaptcha, login } from '../api/auth';

const LOGIN_STORAGE_KEY = 'codex-api-login-user';
const TOKEN_STORAGE_KEY = 'codex-api-auth-token';
const LAST_EMAIL_STORAGE_KEY = 'codex-api-last-email';

export default {
  name: 'LoginView',
  data() {
    return {
      submitting: false,
      captchaImage: '',
      loginForm: {
        email: window.localStorage.getItem(LAST_EMAIL_STORAGE_KEY) || '',
        password: '',
        captchaId: '',
        captchaCode: '',
        agreed: true
      },
      loginRules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码至少 6 个字符', trigger: 'blur' }
        ],
        captchaCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^[1-9]{4}$/, message: '验证码为 4 位 1-9 数字', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.loadCaptcha();
  },
  methods: {
    async loadCaptcha() {
      try {
        const { data } = await fetchCaptcha();
        if (data && data.code === 0) {
          this.loginForm.captchaId = data.data.captchaId;
          this.loginForm.captchaCode = '';
          this.captchaImage = data.data.imageBase64;
        }
      } catch (error) {
        this.captchaImage = '';
      }
    },
    submitLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) {
          return;
        }
        if (!this.loginForm.agreed) {
          this.$message.warning('请先同意服务条款');
          return;
        }

        this.submitting = true;
        try {
          const { data } = await login(
            this.loginForm.email,
            this.loginForm.password,
            this.loginForm.captchaId,
            this.loginForm.captchaCode
          );
          if (!data || data.code !== 0) {
            this.$message.error((data && data.message) || '登录失败');
            this.loadCaptcha();
            return;
          }

          window.localStorage.setItem(LOGIN_STORAGE_KEY, data.data.email);
          window.localStorage.setItem(TOKEN_STORAGE_KEY, data.data.token);
          window.localStorage.setItem(LAST_EMAIL_STORAGE_KEY, data.data.email);
          this.$message.success('登录成功');
          this.$router.push(this.$route.query.redirect || '/dashboard');
        } catch (error) {
          this.$message.error('登录失败，请检查后端服务');
          this.loadCaptcha();
        } finally {
          this.submitting = false;
        }
      });
    }
  }
};
</script>
